import { data_from_server_post } from '@/shared/http/client';

/**
 * The `evaluation` response for one run, looked up by id. Unlike the default
 * lookup, which shows the newest run that did not fail, this also returns a
 * failed run. Resolves to undefined, without a toast, when the request fails.
 */
export function fetchEvaluationRun({ clientId, usecaseId, runId, version }) {
    return data_from_server_post(
        'evaluation',
        {
            client_id: clientId,
            llm_usecase_id: usecaseId,
            version: version ?? null,
            selected_distillation_event_id: runId,
        },
        undefined,
        () => {},
    );
}
